import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { ToastService, Toast } from './toast.service';

@Component({
  selector: 'app-toast',
  imports: [CommonModule],
  templateUrl: './toast.component.html',
  styleUrl: './toast.component.scss',
})
export class ToastComponent implements OnInit, OnDestroy {
  toasts: Toast[] = [];
  private sub!: Subscription;

  constructor(private toastService: ToastService) {}

  ngOnInit(): void {
    this.sub = this.toastService.toast$.subscribe((toast) => {
      if (toast.duration === 0) {
        // Dismiss by id
        this.toasts = this.toasts.filter((t) => t.id !== toast.id);
        return;
      }

      this.toasts = [...this.toasts, toast];

      if (toast.duration && toast.duration > 0) {
        setTimeout(() => this.remove(toast.id), toast.duration);
      }
    });
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  remove(id: number): void {
    this.toasts = this.toasts.filter((t) => t.id !== id);
  }

  trackById(_index: number, toast: Toast): number {
    return toast.id;
  }

  iconPath(type: string): string {
    switch (type) {
      case 'success':
        return 'M20 6L9 17l-5-5';
      case 'error':
        return 'M18 6L6 18M6 6l12 12';
      case 'warning':
        return 'M12 9v4m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z';
      default:
        return 'M12 2a10 10 0 100 20 10 10 0 000-20zm0 5v5m0 2h.01';
    }
  }
}
